/**
 * @file: useTimer.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useCallback, useEffect, useMemo, useRef } from 'react';

export const useTimer = (options?: { repeat?: boolean }) => {
  const timer = useRef<any>();
  const repeat = options?.repeat ?? false;

  const clear = useCallback(() => {
    if (timer.current) {
      if (repeat) {
        clearInterval(timer.current);
      } else {
        clearTimeout(timer.current);
      }
      timer.current = undefined;
    }
  }, [repeat]);

  const schedule = useCallback(
    (callback: () => void, ms?: number) => {
      clear();
      if (repeat) {
        timer.current = setInterval(callback, ms);
      } else {
        timer.current = setTimeout(callback, ms);
      }
    },
    [clear, repeat],
  );

  useEffect(
    () => () => {
      clear();
    },
    [clear],
  );

  return useMemo(() => ({ schedule, clear, timer }), [clear, schedule]);
};
